import { gql } from "@apollo/client";
import { FeatureTypes } from "entity-app/constants";

// All design packages in the project, each with its ordered milestones — one
// query so the modal's DP→Milestone dropdowns need no per-row fetch.
export const DSM_DESIGN_PACKAGES = gql`
  query DsmDesignPackages {
    feature_instance(
      where: {
        feature_type_id: { _eq: ${FeatureTypes.DESIGN_PACKAGE} }
        deleted: { _eq: false }
      }
      order_by: { number: asc, auto_inc_value: asc }
    ) {
      id
      number
      title
      workflow_instance_milestones(order_by: { sequence_no: asc_nulls_last }) {
        id
        name
      }
      linkedBidPackages: links_as_source(
        where: {
          target_feature_instance: {
            feature_type_id: { _eq: ${FeatureTypes.BID_PACKAGE} }
            deleted: { _eq: false }
          }
        }
      ) {
        target_feature_instance {
          id
        }
      }
    }
  }
`;

/** Debounced UniFormat / MasterFormat typeahead — never dumps the full catalog. */
export const SEARCH_CLASSIFICATION_ITEMS = gql`
  query searchClassificationItems(
    $where: classification_items_bool_exp!
    $limit: Int!
  ) {
    classification_items(
      where: $where
      limit: $limit
      order_by: [{ number: asc }]
    ) {
      id
      number
      title
      system
      version
      parent_id
    }
  }
`;

/** Fetch by catalog id for `parent_id` ancestry walks after a pick. */
export const CLASSIFICATION_ITEMS_BY_IDS = gql`
  query classificationItemsByIds($where: classification_items_bool_exp!) {
    classification_items(where: $where) {
      id
      number
      title
      system
      version
      parent_id
    }
  }
`;

/** User's last Design Scope log column layout (order / visibility / filters). */
export const QUERY_GET_DESIGN_SCOPE_COLUMN_CONFIG = `
  GetSavedDesignScopeColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      design_scope_column_config
    }
  }
`;
